import { Component, OnInit } from '@angular/core';
import { EcommerceService } from 'src/app/shared/services/ecommerce.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {

  public openCart: boolean = false;
  cartItems: any[] = [];
  total: number = 0;

  constructor(
    private _cartService: EcommerceService
  ) { }

  ngOnInit() {
    this._cartService.cart$.subscribe(cart => {
      this.cartItems = cart;
      this.total = this._cartService.getTotal();
    });
  }

  toggleCart() {
    this.openCart = !this.openCart;
  }

  updateQuantity(product: any, change: number) {
    const cart = this._cartService.getCartItems();
    const productIndex = cart.findIndex(item => item.productId === product.productId);

    if (productIndex !== -1) {
      cart[productIndex].quantity = Math.max(1, cart[productIndex].quantity + change);
      cart[productIndex].subtotal = this._cartService.calculateItemSubtotal(cart[productIndex]);
      this._cartService.updateCart(cart);
    }
  }

  removeFromCart(product: any) {
    this._cartService.removeFromCart(product.productId);
  }

  onQuantityChange(product: any, event: Event) {
    const input = event.target as HTMLInputElement;
    let newQuantity = parseInt(input.value, 10);

    // Validar que el valor sea un número válido mayor o igual a 1
    if (isNaN(newQuantity) || newQuantity < 1) {
      newQuantity = 1;
    }

    // Actualizar la cantidad y el subtotal en el carrito
    const cart = this._cartService.getCartItems();
    const productIndex = cart.findIndex(item => item.productId === product.productId);

    if (productIndex !== -1) {
      cart[productIndex].quantity = newQuantity;
      cart[productIndex].subtotal = this._cartService.calculateItemSubtotal(cart[productIndex]);
      this._cartService.updateCart(cart);
    }
  }

  hasOriginalPrice(product: any): boolean {
    return !!product?.originalUnitSalePrice && product.originalUnitSalePrice > product.unitSalePrice;
  }

  getPromotionSummary(product: any): string | null {
    const type = (product?.ecommerceDiscountType || "").toUpperCase();

    if (type === "BUY_X_GET_Y" && (product?.ecommerceBuyQuantity || 0) > 0 && (product?.ecommercePayQuantity || 0) >= 0) {
      return `Promo ${product.ecommerceBuyQuantity}x${product.ecommercePayQuantity}`;
    }

    if (type === "PERCENTAGE" && product?.ecommerceDiscountValue) {
      return `${product.ecommerceDiscountValue}% OFF`;
    }

    if (type === "FIXED" && product?.ecommerceDiscountValue) {
      return `${product.ecommerceDiscountValue} OFF`;
    }

    return product?.ecommerceHighlightText || null;
  }

}
